import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent } from '@ap/button';
import { ApFormControlPipe } from '@ap/cdk';
import { ApContentModule } from '@ap/content';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApPincodeInputComponent } from '@ap/input/pincode';

import { VerifyPincodeComponent } from './verify-pincode.component';

/**
 * @ngdoc module
 * @name VerifyPincodeModule
 **/
@NgModule({
    imports: [ApContentModule, ApButtonComponent, ApFormErrorsComponent, ApFormControlPipe, ApPincodeInputComponent, ReactiveFormsModule],
    declarations: [VerifyPincodeComponent],
    exports: [VerifyPincodeComponent]
})
export class VerifyPincodeModule {}
